<template>
    <div class="form__field">
        <label class="input__label">{{ $t(label) | capitalize }}</label>
        <select
            :value="value"
            @input="onInput"
            @blur="onBlur"
            :class="{ 'is-invalid': errorMessage }"
            class="select__field form-control form-control-sm"
            v-bind="$attrs"
        >
            <option
                value=""
            >
                {{ $t(label) | capitalize }}{{ labelSuffix }}
            </option>
            <option
                v-for="option in options"
                :value="option[idField]"
                :key="option[idField]"
            >
                {{ displayValue(option) }}
            </option>
        </select>

        <div v-if="errorMessage"
             class="message message--error"
        >
            <i class="icon icon--xs icon-warning_triangle" />

            {{ errorMessage }}

        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.component('CustomSelect', {
        props: {
            value: {
                type: [Number, String],
                required: false,
                default: null,
            },
            name: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: false,
                default: ''
            },
            labelSuffix: {
                type: String,
                required: false,
                default: ''
            },
            options: {
                type: Array,
                required: true
            },
            displayField: {
                type: String,
                required: false,
            },
            displayFunction: {
                type: Function,
                required: false,
            },
            selected: {
                type: Object,
                required: false,
                default: null,
            },
            isRequired: {
                type: Boolean,
                required: false,
                default: false,
            },
            errorMessage: {
                type: String,
                required: false,
                default: null,
            },
            idField: {
                type: String,
                required: false,
                default: 'id'
            },
        },
        data() {
            return {
                isDirty: false,
                error: '',
                filterInput: '',
            };
        },
        methods: {
            onInput(e) {
                this.isDirty = true;
                this.$emit('input', e.target.value);
                this.$emit('valueChanged', e.target.value, this.name);
            },
            onBlur() {
                this.$emit('blur', this.name, this.value, this.isDirty);
            },
            onFilterInput(value) {
                this.filterInput = value;
                this.$emit('filterInput', this.filteredOptions);
            },
            displayValue(option) {
                if (this.displayField) {
                    return option[this.displayField];
                }

                return this.displayFunction(option);
            }
        },
    });
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/components/forms/CustomSelect.vue